<div class="color-bar"></div>

<div class="conteudo one-page-volvo">
  <div class="container-fluid cartoes one-page-container" style="background-color: #fff;">

    <!-- FILTROS PADRÃO PORTAL -->
    <div class="row faixa-conteudo pt0">
      <div class="col col-lg-12">
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">

            <div class="filtro-dash">
              <div>
                <div class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                  Dealers:
                </div>

                <span
                  class="btn btn-outline-info btn-sm"
                  *ngFor="let dealer of filtrosDealers.selecionados()"
                  style="margin: 6px 2px 0px 2px; text-transform: uppercase;"
                  (click)="removerDealer(dealer)">
                  {{ dealer.nome }}
                  <i class="fa fa-times" aria-hidden="true"></i>
                </span>

                <div class="botao">
                  <button
                    class="btn btn-info btn-sm"
                    type="button"
                    (click)="selecionarDealer()">
                    <em class="fa fa-plus"></em>
                  </button>
                </div>

                <div class="clear"></div>
              </div>
            </div>

            <hr>

            <div class="row ptb50">
              <div class="col col-4">
                <div class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  Data Inicial:
                </div>

                <p-calendar
                  [(ngModel)]="dataInicial"
                  dateFormat="dd/mm/yy"
                  [showIcon]="true"
                  icon="pi pi-calendar"
                  styleClass="p-inputtext-sm"
                  [style]="{'minWidth':'100%'}"
                  [yearNavigator]="true"
                  [monthNavigator]="true"
                  yearRange="2000:2030"
                  showButtonBar="true"
                  (onClearClick)="limpaDataInicial()">
                </p-calendar>
              </div>

              <div class="col col-4">
                <div class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  Data Final:
                </div>

                <p-calendar
                  [(ngModel)]="dataFinal"
                  dateFormat="dd/mm/yy"
                  [showIcon]="true"
                  icon="pi pi-calendar"
                  styleClass="p-inputtext-sm"
                  [style]="{'minWidth':'100%'}"
                  [yearNavigator]="true"
                  [monthNavigator]="true"
                  yearRange="2000:2030"
                  showButtonBar="true"
                  (onClearClick)="limpaDataFinal()">
                </p-calendar>
              </div>

              <div class="col col-4">
                <button
                  type="button"
                  class="btn btn-primary mt-3 mr-2"
                  (click)="filtroAPI()">
                  Filtrar
                  <i class="fas fa-search"></i>
                </button>

                <button
                  type="button"
                  class="btn btn-outline-primary mt-3 mr-2"
                  (click)="limparFiltros()">
                  Limpar filtros
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button>

                <button
                  pButton
                  class="p-button-outlined p-button-secondary p-button-sm float-right mt-3"
                  type="button"
                  (click)="exportExcel()">
                  <i class="fa fa-download mr-1"></i>
                  Export Excel
                </button>
              </div>
            </div>

            <hr>

          </div>
        </div>
      </div>
    </div>

    <!-- LOADING -->
    <div class="loading-box" *ngIf="loading">
      <p-progressSpinner></p-progressSpinner>
      <span>Carregando layout...</span>
    </div>

    <!-- DASHBOARD PRINCIPAL -->
    <div class="layout-dashboard" *ngIf="!loading">

      <!-- COLUNA FATURAMENTO -->
      <div class="layout-painel painel-faturamento">
        <div class="layout-titulo titulo-faturamento">
          Faturamento
        </div>

        <div class="layout-coluna">
          <ng-container *ngFor="let bloco of blocos">
            <ng-container *ngIf="bloco.faturamento">
              <ng-container
                *ngTemplateOutlet="tabelaDashboard; context: { secao: bloco.faturamento }">
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <!-- COLUNA MARGEM BRUTA -->
      <div class="layout-painel painel-margem">
        <div class="layout-titulo titulo-margem">
          Margem Bruta
        </div>

        <div class="layout-coluna">
          <ng-container *ngFor="let bloco of blocos">
            <ng-container *ngIf="bloco.margem">
              <ng-container
                *ngTemplateOutlet="tabelaDashboard; context: { secao: bloco.margem }">
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>

    </div>

    <!-- ORDENS DE SERVIÇO -->
    <div class="ordens-wrapper" *ngIf="!loading">
      <ng-container *ngFor="let secao of ordensServico">
        <ng-container
          *ngTemplateOutlet="tabelaDashboard; context: { secao: secao }">
        </ng-container>
      </ng-container>
    </div>

    <!-- NOTA ABSORÇÃO -->
    <div class="nota-absorcao" *ngIf="!loading">
      <div class="nota-label">
        Nota Absorção
      </div>

      <div class="nota-campo">
        {{ taxaAbsorcao }}
      </div>
    </div>

  </div>
</div>

<!-- TEMPLATE DAS TABELAS -->
<ng-template #tabelaDashboard let-secao="secao">
  <div class="dashboard-section" [ngClass]="secao.classe">

    <div class="section-title">
      <strong>{{ secao.titulo }}</strong>
      <span *ngIf="secao.subtitulo">{{ secao.subtitulo }}</span>
    </div>

    <table class="one-page-table">
      <thead>
        <tr>
          <th class="descricao-col"></th>
          <th *ngFor="let coluna of secao.colunas">
            {{ coluna }}
          </th>
        </tr>
      </thead>

      <tbody>
        <tr
          *ngFor="let linha of secao.linhas"
          [class.total-row]="linha.destaque">
          <td class="descricao-col">
            {{ linha.descricao }}
          </td>

          <td *ngFor="let coluna of secao.colunas">
            {{ getValor(linha, coluna) }}
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</ng-template>

<!-- MODAL DEALERS -->
<p-dialog
  header="Selecione os Dealers"
  [(visible)]="displayFiltrosDealers"
  [style]="{width: '800px'}"
  [modal]="true"
  [draggable]="false">

  <div class="d-flex flex-wrap">
    <ng-container *ngFor="let item of filtrosDealers.naoSelecionados()">
      <span
        class="btn btn-primary btn-sm itemListaSelecao"
        style="font-size: 14px; margin: 2px;"
        (click)="onAdicionarDealerFiltro(item)">
        {{ item.toTexto ? item.toTexto() : item.nome }}
      </span>
    </ng-container>
  </div>

</p-dialog>